export const columns = [
  {
    id: "IVNUM",
    align: "inherit",
    label: "Invoice",
    tooltip: "Invoice number",
    hidden: false,
    doitEmployee: false,
  },
  {
    id: "_STATUS_ID",
    align: "inherit",
    label: "Status",
    tooltip: "Invoice status",
    hidden: false,
    doitEmployee: false,
  },
  {
    id: "CDES",
    align: "inherit",
    label: "Billing profile",
    tooltip: "Billing Profile Name",
    hidden: true,
    doitEmployee: false,
  },
  {
    id: "IVDATE",
    align: "inherit",
    label: "Invoice date",
    tooltip: "Invoice Date",
    hidden: true,
    doitEmployee: false,
  },
  {
    id: "PAYDATE",
    align: "inherit",
    label: "Due date",
    tooltip: "Due Date",
    hidden: true,
    doitEmployee: false,
  },
  {
    id: "ESTPAYDATE",
    align: "inherit",
    label: "Expected",
    tooltip: "Exptected Pay Date",
    hidden: true,
    doitEmployee: true,
  },
  {
    id: "LINKEDINVOICES",
    align: "inherit",
    label: "Linked invoices",
    tooltip: "Linked invoices",
    hidden: false,
    doitEmployee: true,
    ccFees: true,
  },
  {
    id: "TOTPRICE",
    align: "right",
    label: "Total",
    tooltip: "Total Amount",
    hidden: true,
    doitEmployee: false,
  },
  {
    id: "TOTALWFEES",
    align: "right",
    label: "Total w/ fees",
    tooltip: "Total with fees",
    hidden: false,
    doitEmployee: true,
    ccFees: true,
  },
  {
    id: "DEBIT",
    align: "right",
    label: "Balance",
    tooltip: "Invoice Balance",
    hidden: false,
    doitEmployee: false,
  },
] as const;
